// src/features/inventory/services/valuation.js
import { apiClient } from '../../../services/api/client';

// Cost prices and stock value. All amounts are DKK incl. moms.
export const valuationAPI = {
  getSummary: () =>
    apiClient.get('/api/v1/inventory/valuation/summary'),

  getItems: ({ productGroupId = null } = {}) => {
    const params = new URLSearchParams();
    if (productGroupId) params.set('product_group_id', productGroupId);
    const query = params.toString();
    return apiClient.get(`/api/v1/inventory/valuation/items${query ? `?${query}` : ''}`);
  },

  getItem: (itemId) =>
    apiClient.get(`/api/v1/inventory/valuation/items/${itemId}`),

  setCostPrice: (itemId, costPrice, { recostFilled = false } = {}) =>
    apiClient.put(`/api/v1/inventory/valuation/items/${itemId}/cost-price`, {
      cost_price: costPrice,
      recost_filled: recostFilled,
    }),

  // Change the price of every active item in the groups by a percentage or an amount (signed)
  adjustCostPrices: ({ productGroupIds, mode, value }) =>
    apiClient.post('/api/v1/inventory/valuation/price-adjustment', {
      product_group_ids: productGroupIds,
      mode,
      value,
    }),
};
